import axios from 'axios'
import { traceRequestInterceptor } from './trace'
axios.defaults.withCredentials = true
axios.interceptors.request.use(traceRequestInterceptor)

let configurl = null
if (window.zzzconfig) {
  // const server = {
  //   "fosun": "https://ms-trip.fosun.com",
  //   "fosunadmin": "https://ms-trip.fosun.com",
  //   "chambroad": "https://ms-trip.chambroad.com",
  //   "jbadmin": "https://ms-trip.chambroad.com",
  //   "sunac": "https://ms-trip.sunac.com.cn",
	//   "shenergy": "https://ms-trip.shenergy.com.cn",
  //   "-test.z-trip.cn": "https://ms-test.z-trip.cn"
  // }
  for (var key in window.zzzconfig.server) {
    if (location.host.indexOf(key) != -1) {
      configurl = window.zzzconfig.server[key]
      break
    }
  }
}

// 渠道配置信息，默认从ztrip服务器读取
let baseURL = configurl || (window.location.host.indexOf('-uat') != -1 ? 'https://ms-uat.z-trip.cn' : 'https://ms.z-trip.cn')
console.log(configurl, 'configurl')
const defaultConfig = {
  NAME: '在途商旅',
  LOGO_ICO: 'https://tem-public.oss-cn-shanghai.aliyuncs.com/logo/z-trip_cn/favicon.ico',
  // 一般包含logo名称的logo
  LOGO_NAME: 'https://tem-public.oss-cn-shanghai.aliyuncs.com/logo/z-trip_cn/logoname.png',
  // 简单logo：loading
  LOGO: 'https://tem-public.oss-cn-shanghai.aliyuncs.com/logo/z-trip_cn/index.png',
  LOGO_WHITE: 'https://static.service.z-trip.cn/logo/z-trip_cn/logowhite.png',
  // 服务地址
  DOMAIN_MS: baseURL,
  // 登录中心地址
  DOMAIN_PASSPORT: 'https://passport.z-trip.cn',
  // 移动端网站域名
  DOMAIN_H5: 'https://m.z-trip.cn',
  // PC端网站域名
  DOMAIN_WWW: 'https://www.z-trip.cn',
  DOMAIN_IMG: 'https://img.z-trip.cn',
  // ADMIN端网站域名
  DOMAIN_ADMIN: 'https://admin.z-trip.cn',
  DOMAIN_PUB_IMG: 'https://static.service.z-trip.cn',
  // 客服电话
  CUSTOM_PHONE: '400-010-5050',
  // app应用编码，无配置则不绑定设备，不推送
  APP_CODE: null,
  THEME: null
}

// 默认主题
const defaultTheme = 'zblue-pc'

// logo/名称/服务地址系统级别配置 免登
export default class ZConfig {
  constructor() {
    this.store = {}
    this.client = 'pc'
  }

  // 初始化配置，需在vue实例化之前调用
  static async init(withAuth = true ) {
    if (!window.$ZConfig) {
      window.$ZConfig = new ZConfig()
    }
    if (withAuth) { 
      let res = await axios.get('/api/pp/common/pc/common/config', {baseURL, withCredentials: true,
      headers: {
        'Accept-Language': (localStorage.getItem('WEB_LOCALE_LANGUAGE') || 'zh_CN').replace(/_/g, '-')
      }
    })
      window.$ZConfig.handleData(res.data)
      await window.$ZConfig.getCurUserInfo()
      if (window.$ZConfig.getServerUrl() != baseURL) {
        let resAgain = await axios.get('/api/pp/common/pc/common/config', {baseURL: window.$ZConfig.getServerUrl(), withCredentials: true,
          headers: {
            'Accept-Language': (localStorage.getItem('WEB_LOCALE_LANGUAGE') || 'zh_CN').replace(/_/g, '-')
          }
        })

        window.$ZConfig.handleData(resAgain.data)
      }
    } else {
      // 非授权初始化, 只获取需要的请求资源
      let res = await axios.get('/api/pp/common/pc/common/config', {baseURL, withCredentials: false,
        headers: {
          'Accept-Language': (localStorage.getItem('WEB_LOCALE_LANGUAGE') || 'zh_CN').replace(/_/g, '-')
        }
      })
      window.$ZConfig.handleData(res.data)
    }

  }

  handleData(res) {
    if (res.code == '0') {
      let systemConfig = res.data || {}
      for (let key in systemConfig) {
        if (systemConfig[key] != null) {
          defaultConfig[key] = systemConfig[key]
        }
      }
      // $tool.ss.setItem(zconfigKey, defaultConfig)
    } else {
      alert('服务配置信息服务异常1，请稍后再试')
    }
    if (defaultConfig.TM_PARTNER_NAME) {
      defaultConfig.NAME = defaultConfig.TM_PARTNER_NAME
    }
    this.store = defaultConfig
    this.initAppInfo()
  }

  reload(callback) {
    axios.get('/api/pp/common/pc/common/config',{baseURL: this.getServerUrl(), withCredentials: true,
      headers: {
        'Accept-Language': (localStorage.getItem('WEB_LOCALE_LANGUAGE') || 'zh_CN').replace(/_/g, '-')
      }
    }).then(res => {
      this.handleData(res.data)
      callback(res.data)
    }).catch(err => {
      console.log(err)
      alert('服务配置信息获取异常2，请稍后再试')
    })
  }

  // 获取服务地址
  getServerUrl() {
    return this.client == 'pc' ? this.appendUAT(this.getVal('DOMAIN_MS')) : this.appendUAT(this.getVal('DOMAIN_ADMIN'))
  }

  // 获取登录中心地址
  getPassportUrl() {
    return this.appendUAT(this.getVal('DOMAIN_PASSPORT'))
  }

  getOrigin() {
    return this.client == 'pc' ? this.getUrl('DOMAIN_WWW') : this.getUrl('DOMAIN_ADMIN')
  }

  // 判断是否是测试环境
  isUAT() {
    return window.location.host.indexOf('-uat') != -1 || window.location.host.indexOf('-dev') != -1
  }

  // 测试环境下：前缀加-uat。例如：m-uat.z-trip.cn ms-uat.z-trip.cn
  appendUAT(url) {
    if (!url) {
      console.log('url is null')
      return null
    }
    // 测试环境下：前缀加-uat。
    if (this.isUAT() && url.indexOf('-uat') == -1 ) {
      if (url.indexOf('.ding') != -1) {
        url = url.replace('.ding', '.ding-uat')
      } else if (url.indexOf('.service') != -1) {
        // 例如：aoyuan-payment.service.z-trip.cn
        url = url.replace('.service', '.service-uat')
      } else {
        // 例如：m-uat.z-trip.cn ms-uat.z-trip.cn payment-uat.z-trip.cn
        let i = url.indexOf('.')
        if (i != -1) {
          url = url.substr(0, i) + '-uat' + url.substr(i)
        }
      }
    }
    return url.startsWith('http') ? url : 'https://' + url
  }

  // 获取配置值
  getVal(key) {
    return this.store[key]
  }

  // 获取一个是地址的配置，主要会封装uat参数
  getUrl(key) {
    return this.appendUAT(this.getVal(key))
  }

  initAppInfo() {
    // 已经登录过
    if (this.getVal('hasPartner')) {
      this.initTitle()
    }
    // 初始化主题方案
    this.initTheme()
  }

  initTitle() {
    // 网页标题
    document.querySelector('title').innerHTML = this.client == 'pc' ? this.getVal('NAME') : '商旅助手管理系统'
    // 网页ico
    if (!document.getElementById('z-icon')) {
      let iconDom = document.createElement('link')
      iconDom.id = 'z-icon'
      iconDom.rel = 'icon'
      iconDom.href = this.getVal('LOGO_ICO')
      document.querySelector('head').appendChild(iconDom)
    }

    // 初始化主题方案
    if (this.client == 'pc') {
      this.initTheme()
    }
  }

  // 切换主题
  initTheme(theme) {
    // 暂不缓存主题信息
    // if (theme) {
    //   localStorage.setItem('theme', theme)
    // }
    // // 当前主题
    // let currentTheme = localStorage.getItem('theme') || this.getVal('THEME') || defaultTheme
    let currentTheme = theme || this.getVal('THEME') || defaultTheme
    this.store.currentTheme = currentTheme
    // 从本地读取主题样式
    // require('../../static/theme/' + theme + '.css')
    // 从oss服务器读取主题样式
    $tool.loadCSS('https://static.service.z-trip.cn/app/theme/' + currentTheme + '.css', 'theme')
  }

  // 获取主题icon
  getThemeIcon(code) {
    let curTheme = this.store.currentTheme
    return curTheme == defaultTheme ? code : code + '-' + curTheme
  }

  // 获取当前登录用户信息
  async getCurUserInfo() {
    let userInfo = this.store.userInfo
    if (userInfo && userInfo.userId) {
      return userInfo
    }
    //防止重复发送请求
    if (this.loading) {
      // 等待已有请求完成，最多重试50次（约5秒）
      let retryCount = 0
      const maxRetries = 50
      while (this.loading && retryCount < maxRetries) {
        await new Promise((resolve) => {
          setTimeout(resolve, 100)
        })
        retryCount++
      }
      // 如果等待后已有结果，直接返回
      if (this.store.userInfo && this.store.userInfo.userId) {
        return this.store.userInfo
      }
      // 超时仍未完成，重置loading允许重新请求
      if (this.loading) {
        this.loading = false
      }
    }
    this.loading = true
    let data
    try {
      const res = await axios.get('/api/pp/common/members/personalInfo/v2/pc/or', {baseURL: this.getServerUrl(), withCredentials: true,
        headers: {
          'Accept-Language': (localStorage.getItem('WEB_LOCALE_LANGUAGE') || 'zh_CN').replace(/_/g, '-')
        }
      })
      data = res.data
    } catch (err) {
      console.error('getCurUserInfo 请求失败:', err)
      this.loading = false
      return {}
    }
    if (!data) {
      return {}
    }
    if (data.code == '-99') {
      this.loading = false
      // window.$jump && window.$jump.toLogin()
      return {}
    }
    if(!data.data.userDto){
      // alert(data.msg || '服务异常')
      return {}
    }
    let userState = {
      '0': '未审核',
      '1': '已审核',
      '-10': '已冻结',
      '-99': '已失效'
    }
    let user = data.data.userDto
    let {flightOverproofSelfPay,bizBeyondTandardTravel} = data.data.controlRuleForm
    const beyondTandardTravel = bizBeyondTandardTravel && bizBeyondTandardTravel.flightProcessRule
    const initBeyondTandardTravel = bizBeyondTandardTravel && bizBeyondTandardTravel.intFlightProcessRule
    // ! 不可为所有人预订 && 不可为员工预订 && 不可为非员工预订 && 无特殊代订范围
    let i_only = !window.$ZConfig.getVal('notLimit') && !window.$ZConfig.getVal('allowProxy') &&window.$ZConfig.getVal('notAllowProxyNonEmp') && !window.$ZConfig.getVal('isHasSpecialBookers')
    userInfo = {
      userDto: user,
      userId: user.id,
      name: user.fullname,
      corpId: user.corpId,
      corpName: user.corpName,
      orgId: user.org ? user.org.id : user.orgId,
      orgName: user.orgName,
      partnerId: user.partnerId,
      partnerName: data.data.company,
      hasRiskFlag: !!(data.manageOrgList || []).length,
      companyName: data.company,
      status: user.status,
      statusTxt: userState[user.status] || '',
      photoUrl: user.photo,
      mobile: user.mobile,
      mobileAreaCode:user.mobileAreaCode || '+86',
      companyPosition: user.title,
      email: user.email,
      cardType: user.userCert,
      country: user.country,
      countryCode: user.countryCode,
      birthday: user.birthDay,
      gender: user.gender,
      title: user.title,
      empCode: user.empCode,
      travelLevel: user.trLevel,
      companyInfo: data.partnerList,
      firstName: user.firstName,
      lastName: user.lastName,
      rank: user.rank,
      rankName: user.rankName,
      sex: user.gender,
      vip: user.vip,
      tmcId: user.tmcId,
      hasApproveAuth: data.data.hasApproveAuth,
      hasReApproveAuth: data.data.hasReApproveAuth,
      // bizEnable: bizEnable,
      passengerSwitch: data.data.trainRule.passengerSwitch == 1,
      // integralSwitch,
      notLimit: window.$ZConfig.getVal('notLimit'),
      allowProxy: window.$ZConfig.getVal('allowProxy'),
      notAllowProxyNonEmp: window.$ZConfig.getVal('notAllowProxyNonEmp'),
      hideOrgSearch: window.$ZConfig.getVal('hideOrgSearch'),
      canSelUser: window.$ZConfig.getVal('notLimit')|| window.$ZConfig.getVal('allowProxy')  || !window.$ZConfig.getVal('notAllowProxyNonEmp') || window.$ZConfig.getVal('isHasSpecialBookers'),
      isCustomer: data.data.isCustomer,
      flightStandardIsDisabled:{

        beyondTandardTravel: !flightOverproofSelfPay && beyondTandardTravel && beyondTandardTravel.includes('拒绝订单'),
        initBeyondTandardTravel: !flightOverproofSelfPay && initBeyondTandardTravel && initBeyondTandardTravel.includes('拒绝订单'),
        // 国际
        intl:!window.$ZConfig.getVal('IS_CUSTOMER') && !window.$ZConfig.getVal('OTA_BOOKING_AGENT') && i_only,
        // 国内
        domestic:!window.$ZConfig.getVal('IS_CUSTOMER') && !window.$ZConfig.getVal('OTA_BOOKING_AGENT') && i_only
      },
      // 火车符合差标是否选中且禁用
      trainStandardIsDisabled: (!window.$ZConfig.getVal('IS_CUSTOMER') && !window.$ZConfig.getVal('OTA_BOOKING_AGENT') && i_only),
      isHasSpecialBookers: window.$ZConfig.getVal('isHasSpecialBookers')
    }
    window.setUnReadCSCount && window.setUnReadCSCount(data.data.unReadCsMsg ? parseInt(data.data.unReadCsMsg) : 0)
    this.store.userInfo = userInfo
    console.log(user)
    console.log(user.fullname)
    console.log(window.moment(new Date()).format('YYYY.MM.DD HH:mm:ss'))
    let localUserInfo = {
      userId: user.id,
      mobile: user.mobile,
      partnerId: user.partnerId,
      rankName: user.rankName,
      userName: user.fullname,
      date: window.moment().format('YYYY.MM.DD HH:mm:ss'),
      partnerName: data.data.company
    }
    localStorage.setItem('localUserInfo', JSON.stringify(localUserInfo))
    localStorage.setItem('userId', localUserInfo.userId)
    localStorage.setItem('pid', localUserInfo.partnerId)
    this.loading = false
    return userInfo
  }
}
